/**
 * Unified status configuration for all entities
 */
export const STATUS_CONFIG = {
  // Codex statuses
  CODEX: {
    DRAFT: { label: 'Bozza', color: 'default' },
    TO_VALIDATE: { label: 'Da Validare', color: 'warning' },
    FAILED: { label: 'Errore', color: 'error' },
    COMPLETED: { label: 'Completato', color: 'success' },
    PENDING: { label: 'Pending', color: 'warning' },
    APPROVED: { label: 'Approved', color: 'success' },
    REJECTED: { label: 'Rifiutato', color: 'error' },
  },
  
  // Process statuses
  PROCESS: {
    PENDING: {code:'PENDING', label: 'In Attesa', color: 'warning' },
    RUNNING: {code:'RUNNING', label: 'In Esecuzione', color: 'info' },
    TO_VALIDATE: {code:'TO_VALIDATE', label: 'Da Validare', color: 'warning' },
    COMPLETED: {code:'COMPLETED', label: 'Completato', color: 'success' },
    FAILED: {code:'FAILED', label: 'Errore', color: 'error' },
    REJECTED: {code:'REJECTED', label: 'Rifiutato', color: 'error' },
    SUSPENDED: {code:'SUSPENDED', label: 'Sospeso', color: 'default' },
    CANCELLED: {code:'CANCELLED', label: 'Annullato', color: 'default' },
  },
  
  // Task statuses
  TASK: {
    PENDING: { label: 'In Attesa', color: 'warning' },
    PROCESSING: { label: 'In Elaborazione', color: 'info' },
    COMPLETED: { label: 'Completato', color: 'success' },
    ERROR: { label: 'Errore', color: 'error' }
  },

  // Registry sync run statuses
  REGISTRY_SYNC: {
    RUNNING: { label: 'In esecuzione', color: 'info' },
    SUCCESS: { label: 'Completata', color: 'success' },
    PARTIAL: { label: 'Parziale', color: 'warning' },
    FAILED: { label: 'Fallita', color: 'error' },
  },

  // Registry entry history change types
  REGISTRY_ENTRY_CHANGE: {
    CREATED: { label: 'Creata', color: 'success' },
    UPDATED: { label: 'Modificata', color: 'info' },
    DELETED: { label: 'Eliminata', color: 'error' },
  },
};

/**
 * Get status configuration for a specific entity type and status
 */
export const getStatusConfig = (entityType, status) => {
  if (!status) return { label: '-', color: 'default' };
  return STATUS_CONFIG[entityType]?.[status] || { label: status, color: 'default' };
}; 